import { memo, SVGProps } from 'react';

function CalendarIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      data-testid="bannerCalendarIcon"
      {...props}
    >
      <path
        d="M21.334 2.87329C21.6099 2.87355 21.834 3.09731 21.834 3.37329V5.54028H27.834V26.0403C27.8339 27.7891 26.4158 29.2063 24.667 29.2063H7.33398C5.58516 29.2063 4.16713 27.7891 4.16699 26.0403V8.7063C4.16721 6.95758 5.58522 5.54028 7.33398 5.54028H10.167V3.37329C10.167 3.09715 10.3909 2.87329 10.667 2.87329C10.9431 2.87329 11.167 3.09715 11.167 3.37329V5.54028H20.834V3.37329C20.834 3.09715 21.0578 2.87329 21.334 2.87329ZM5.16699 26.0403C5.16713 27.2368 6.13745 28.2063 7.33398 28.2063H24.667C25.8635 28.2063 26.8339 27.2368 26.834 26.0403V10.5872H5.16699V26.0403ZM10.9385 20.7971C11.4908 20.7971 11.9385 21.2448 11.9385 21.7971V24.2346C11.9385 24.7869 11.4908 25.2346 10.9385 25.2346H8.5C7.94783 25.2345 7.5 24.7868 7.5 24.2346V21.7971C7.5 21.2449 7.94783 20.7973 8.5 20.7971H10.9385ZM17.1787 20.7971C17.7309 20.7972 18.1787 21.2449 18.1787 21.7971V24.2346C18.1787 24.7869 17.7309 25.2345 17.1787 25.2346H14.7402C14.1879 25.2346 13.7402 24.7869 13.7402 24.2346V21.7971C13.7402 21.2448 14.1879 20.7971 14.7402 20.7971H17.1787ZM23.5 20.7883C24.0523 20.7883 24.5 21.236 24.5 21.7883V24.2268C24.4999 24.779 24.0522 25.2268 23.5 25.2268H21.0625C20.5103 25.2268 20.0626 24.779 20.0625 24.2268V21.7883C20.0625 21.236 20.5102 20.7883 21.0625 20.7883H23.5ZM8.5 24.2346H10.9385V21.7971H8.5V24.2346ZM14.7402 24.2346H17.1787V21.7971H14.7402V24.2346ZM21.0625 24.2268H23.5V21.7883H21.0625V24.2268ZM10.9385 13.5686C11.4908 13.5686 11.9385 14.0163 11.9385 14.5686V17.0071C11.9383 17.5592 11.4906 18.0071 10.9385 18.0071H8.5C7.94796 18.0069 7.50021 17.5591 7.5 17.0071V14.5686C7.5 14.0164 7.94783 13.5687 8.5 13.5686H10.9385ZM17.1787 13.5686C17.7309 13.5687 18.1787 14.0164 18.1787 14.5686V17.0071C18.1785 17.5591 17.7308 18.007 17.1787 18.0071H14.7402C14.1881 18.0071 13.7404 17.5592 13.7402 17.0071V14.5686C13.7402 14.0163 14.188 13.5686 14.7402 13.5686H17.1787ZM23.5 13.5598C24.0522 13.5598 24.4999 14.0076 24.5 14.5598V16.9983C24.5 17.5506 24.0523 17.9983 23.5 17.9983H21.0625C20.5102 17.9983 20.0625 17.5506 20.0625 16.9983V14.5598C20.0626 14.0076 20.5103 13.5598 21.0625 13.5598H23.5ZM8.5 17.0071H10.9385V14.5686H8.5V17.0071ZM14.7402 17.0071H17.1787V14.5686H14.7402V17.0071ZM21.0625 16.9983H23.5V14.5598H21.0625V16.9983ZM7.33398 6.54028C6.1375 6.54028 5.16721 7.50987 5.16699 8.7063V9.58716H26.834V6.54028H21.834V7.37329C21.834 7.64927 21.6099 7.87303 21.334 7.87329C21.0578 7.87329 20.834 7.64943 20.834 7.37329V6.54028H11.167V7.37329C11.167 7.64943 10.9431 7.87329 10.667 7.87329C10.3909 7.87329 10.167 7.64943 10.167 7.37329V6.54028H7.33398Z"
        fill="#333333"
      />
    </svg>
  );
}

function WarningIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      data-testid="bannerWarningIcon"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0751 5.7616L3.74176 23.0433C3.17828 24.0759 3.20082 25.3291 3.80107 26.3408C4.40132 27.3525 5.49039 27.9729 6.66676 27.9733H25.3334C26.5098 27.9729 27.5989 27.3525 28.1991 26.3408C28.7994 25.3291 28.8219 24.0759 28.2584 23.0433L18.9251 5.7616C18.3406 4.69208 17.2189 4.02686 16.0001 4.02686C14.7813 4.02686 13.6596 4.69208 13.0751 5.7616V5.7616Z"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M15.9998 10.6433V20.06" stroke="#333333" strokeLinecap="round" strokeLinejoin="round" />
      <ellipse
        cx="16.0002"
        cy="23.31"
        rx="0.166667"
        ry="0.166667"
        stroke="#333333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse cx="16.0002" cy="23.31" rx="0.828333" ry="0.828334" fill="#333333" />
    </svg>
  );
}

function PencilIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      data-testid="bannerPencilIcon"
      {...props}
    >
      <path
        d="M23.696 4.15857C24.3187 4.15857 24.916 4.40759 25.3542 4.84998L28.7028 8.23962L24.9177 12.0385L24.9157 12.0404L10.7995 26.2308C10.7354 26.2953 10.6552 26.3415 10.5671 26.3636L4.74971 27.8187C4.57942 27.8612 4.39923 27.811 4.2751 27.6869C4.15097 27.5628 4.10077 27.3826 4.14326 27.2123L5.59639 21.3959C5.61833 21.308 5.66425 21.2275 5.72822 21.1635L19.8903 7.00037C19.8963 6.99371 19.9015 6.98626 19.9079 6.97986L22.0388 4.849C22.4769 4.40719 23.0738 4.15859 23.696 4.15857ZM6.53389 21.7719L5.31611 26.6459L10.1892 25.4271L10.2419 25.3734L6.58662 21.7181L6.53389 21.7719ZM7.29365 21.0111L10.947 24.6644L23.8591 11.684L20.2604 8.04529L7.29365 21.0111ZM23.696 5.15857C23.3403 5.15859 22.9991 5.30046 22.7487 5.5531L20.9655 7.3363L24.5651 10.975L27.2946 8.23669L24.6433 5.5531C24.3929 5.30057 24.0516 5.15857 23.696 5.15857Z"
        fill="#333333"
      />
    </svg>
  );
}

function ClockIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M29.166 16.0003C29.1658 23.2718 23.2715 29.1661 16 29.1663C8.72836 29.1663 2.83318 23.2719 2.83301 16.0003C2.83301 8.72856 8.72825 2.83331 16 2.83331H29.166V16.0003ZM16 3.83331C9.28054 3.83331 3.83301 9.28084 3.83301 16.0003C3.83318 22.7196 9.28064 28.1663 16 28.1663C22.7192 28.1661 28.1658 22.7195 28.166 16.0003V3.83331H16ZM16 6.87531C16.276 6.87544 16.5 7.09924 16.5 7.37531V15.8343L20.6865 20.0218C20.8817 20.2171 20.8818 20.5336 20.6865 20.7288C20.4913 20.9239 20.1747 20.9239 19.9795 20.7288L15.6465 16.3948C15.5528 16.3011 15.5 16.1739 15.5 16.0413V7.37531C15.5 7.09916 15.7239 6.87531 16 6.87531Z"
        fill="#E60000"
      />
    </svg>
  );
}

export const BannerCalendarIcon = memo(CalendarIcon);
export const BannerWarningIcon = memo(WarningIcon);
export const BannerPencilIcon = memo(PencilIcon);
export const BannerClockIcon = memo(ClockIcon);
